import { isUndefined } from "lodash-es";
import { useEffect, useState } from "react";
import { getPersistedData, persistData } from "utils/persist";

const useHotjarConsent = () => {
  const [isShow, setIsShow] = useState(true);
  const [isHotjarConsent, setHotjarConsent] = useState(false);

  useEffect(() => {
    const persistedValue = getPersistedData("hotjar_consent");
    setIsShow(isUndefined(persistedValue) || persistedValue === 'disagree');
    persistData("hotjar_consent", isUndefined(persistedValue) ? 'disagree' : persistedValue);
  }, []);

  const onToggleHotjarConsent = () => {
    setHotjarConsent(prev => {
      persistData("hotjar_consent", !prev ? 'agree' : 'disagree');
      return !prev
    });
  };

  return { isShow, isHotjarConsent, onToggleHotjarConsent }
}

export default useHotjarConsent;
